import { useParams } from 'next/navigation'
import React from 'react'
import { AddressPickerDecorator } from './address-picker-decorator/AddressPickerDecorator'
import { useDeliveryAddress } from '@/delivery-address/client'
import { AddressPicker } from '@/tools/ui/components/header/ui/address-prompt/address-picker/AddressPicker'

interface Props {
  color?: string
  isIntersecting: boolean
  showLocationScrollDrawer: boolean
}

export const AddressPrompt: React.FC<Props> = ({
  color,
  isIntersecting,
  showLocationScrollDrawer,
}) => {
  const { city } = useParams()
  const isBrandHeader = color === 'brand'
  const { deliveryAddress } = useDeliveryAddress()
  const shouldShowAddressInput = (isIntersecting && isBrandHeader) || !isBrandHeader

  if (!shouldShowAddressInput) {
    return null
  }

  return (
    <AddressPickerDecorator
      city={city}
      deliveryAddressText={deliveryAddress?.text}
      isBrandHeader={isBrandHeader}
    >
      <AddressPicker
        addressText={deliveryAddress?.text}
        color={color}
        isIntersecting={isIntersecting}
        showLocationScrollDrawer={showLocationScrollDrawer}
      />
    </AddressPickerDecorator>
  )
}
